import React from "react";
import { FormattedMessage } from "react-intl";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { Flex, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Card } from "@domestika-dev/prudencio/dist/atoms/Card";
import { List, ListItem } from "../../../../common";

export const LiveSetupLobbyCard = () => {
  return (
    <GridItem
      gridRow="4"
      gridColumn="1 / span 8"
      marginTop={4}
      style={{ overflowY: "auto", overflowX: "hidden" }}
    >
      <Card padding={5} backgroundColor="copoazu">
        <Flex flexDirection="column">
          <List>
            <ListItem>
              <Text size="tiny" as="span" textAlign="left">
                <FormattedMessage id="live_sessions.create_lobby.body_1" />
              </Text>
            </ListItem>
            <ListItem>
              <Text size="tiny" as="span" textAlign="left">
                <FormattedMessage id="live_sessions.create_lobby.body_2" />
              </Text>
            </ListItem>
            <ListItem>
              <Text size="tiny" as="span" textAlign="left">
                <FormattedMessage id="live_sessions.create_lobby.body_3" />
              </Text>
            </ListItem>
            <ListItem isLastChild>
              <Text size="tiny" as="span" textAlign="left">
                <FormattedMessage id="live_sessions.create_lobby.body_4" />
              </Text>
            </ListItem>
          </List>
        </Flex>
      </Card>
    </GridItem>
  );
};

export default LiveSetupLobbyCard;
